var map = {
	"./android-tablet.png": "msr9",
	"./android-tablet@2x.png": "WGs5",
	"./android.png": "NBrx",
	"./android@2x.png": "iU7o",
	"./ipad.png": "8xfg",
	"./ipad@2x.png": "CpBI",
	"./iphone.png": "U5zD",
	"./iphone@2x.png": "XEFS",
	"./m-android-tablet@2x.png": "IKAM",
	"./m-android@2x.png": "hWar",
	"./m-ipad@2x.png": "D5rS",
	"./m-iphone@2x.png": "JpJp",
	"./m-mac@2x.png": "gh08",
	"./m-windows@2x.png": "tUju",
	"./mac.png": "wTIJ",
	"./mac@2x.png": "xMJb",
	"./windows.png": "HrGx",
	"./windows@2x.png": "+hGk"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Kbhc";